var _defs, _path, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconLoginLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .signUp {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "signUp",
    d: "M15.62,14.58v-5.2c0-3.45,2.8-6.24,6.24-6.24h16.65c3.45,0,6.24,2.8,6.24,6.24v31.22c0,3.45-2.8,6.24-6.24,6.24h-16.65c-3.45,0-6.24-2.8-6.24-6.24v-5.2"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "signUp",
    points: "25.18 32.47 32.27 24.99 25.18 17.51"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "signUp",
    x1: 32.27,
    y1: 24.99,
    x2: 5.22,
    y2: 24.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconLoginLine);
export default __webpack_public_path__ + "static/media/cloud_icon_login_line.64790a8018648aac5fba47706971897d.svg";
export { ForwardRef as ReactComponent };